import React from 'react';

export const questions = [
  {
    question: 'Qual é a fórmula do cálcio corrigido pela albumina?',
    answer: 'Cálcio corrigido (mg/dL) = cálcio total + 0,8 × (4,0 − albumina em g/dL). Por exemplo, cálcio total de 8,0 mg/dL com albumina de 2,5 g/dL dá 8,0 + 0,8 × 1,5 = 9,2 mg/dL. É uma estimativa e não substitui a medição do cálcio ionizado quando a decisão depende dele.'
  },
  {
    question: 'Qual o valor normal do cálcio corrigido?',
    answer: 'Em adultos, a referência típica do cálcio total e do corrigido vai de 8,5 a 10,5 mg/dL (2,12 a 2,62 mmol/L). A faixa muda conforme o laboratório; use a referência impressa no seu laudo.'
  },
  {
    question: 'O que é o cálcio iônico?',
    answer: 'É a fração livre e biologicamente ativa do cálcio no sangue, cerca de metade do total. Medido por eletrodo íon-seletivo, não depende da albumina, mas depende do pH da amostra.'
  },
  {
    question: 'Qual o valor de referência do cálcio iônico?',
    answer: 'A referência típica em adultos é de 1,12 a 1,32 mmol/L, equivalente a 4,5 a 5,3 mg/dL. Cada laboratório define a sua faixa, então confira o laudo.'
  },
  {
    question: 'O que significa cálcio iônico baixo?',
    answer: 'Pode indicar hipoparatireoidismo, falta de vitamina D, hipomagnesemia, pancreatite, sepse, doença renal, transfusão maciça ou alcalose. Os sinais são formigamento, câimbras e tetania; valores muito baixos ou sintomas exigem avaliação médica imediata.'
  },
  {
    question: 'O que significa cálcio iônico alto?',
    answer: 'No ambulatório a causa mais comum é o hiperparatireoidismo primário; em internados, neoplasias, excesso de vitamina D, tiazídicos ou lítio. Pode causar sede, constipação, litíase e confusão. Valores muito altos ou sintomas importantes são urgência.'
  },
  {
    question: 'Dá para calcular o cálcio iônico?',
    answer: 'Não com precisão. Equações que o estimam a partir do cálcio total, da albumina e do pH discordam da medição direta, sobretudo em doença crítica e renal. A calculadora desta página estima o cálcio corrigido, não o iônico.'
  },
  {
    question: 'Como converter cálcio de mg/dL para mmol/L?',
    answer: 'Divida o valor em mg/dL por 4,008 para obter mmol/L; para o caminho inverso, multiplique por 4,008. Assim, 10 mg/dL equivalem a cerca de 2,5 mmol/L.'
  },
  {
    question: 'Por que “cálcio corrigido” pode ser um termo enganoso?',
    answer: 'A palavra sugere medida exata, mas o resultado vem de uma fórmula e continua sendo estimativa. Estudos mostram discordância relevante entre cálcio ajustado e ionizado, sobretudo em contextos clínicos complexos.'
  },
  {
    question: 'Por que doença renal e doença crítica limitam a estimativa?',
    answer: 'Nesses quadros, pH, fosfato, proteínas e fluidos alteram a relação entre cálcio total, albumina e fração ionizada, e a fórmula pode discordar do cálcio ionizado medido.'
  },
];

export default function FAQSection() {
  return (
    <section aria-labelledby="faq-heading" className="faq-section">
      <h2 id="faq-heading">Quais dúvidas são comuns sobre cálcio corrigido e cálcio iônico?</h2>
      {questions.map(({ question, answer }) => (
        <article key={question}>
          <h3>{question}</h3>
          <p>{answer}</p>
        </article>
      ))}
    </section>
  );
}
